import {
  gapVerdict,
  type LayoutSibling,
  periodLabel,
  totalGap,
} from '@/modules/projects/components/reconciliation/helpers'
import { needsReview } from '@/modules/projects/status'

export const LayoutSiblingList = ({
  siblings,
}: {
  siblings: LayoutSibling[]
}) => (
  <section className="space-y-1.5">
    <p className="flex items-baseline gap-1.5">
      <span className="text-xs font-normal uppercase tracking-wide text-muted-foreground">
        Other statements to fix
      </span>
      <span className="text-sm font-medium tabular-nums text-foreground">
        {siblings.length}
      </span>
    </p>
    <ul className="max-h-48 divide-y overflow-auto rounded-lg border bg-white">
      {siblings.map(({ statement, segment }) => (
        <li
          key={segment.id}
          className="flex items-center justify-between gap-4 px-3 py-2"
        >
          <div className="min-w-0">
            <p className="truncate text-sm text-foreground">
              {statement.fileName}
            </p>
            <p className="text-xs text-muted-foreground">
              {periodLabel(segment)}
            </p>
          </div>
          <SiblingVerdict segment={segment} />
        </li>
      ))}
    </ul>
  </section>
)

const SiblingVerdict = ({ segment }: { segment: LayoutSibling['segment'] }) => {
  if (!needsReview(segment)) {
    return (
      <span className="shrink-0 text-xs font-medium text-muted-foreground">
        Not checked
      </span>
    )
  }
  const gap = totalGap(segment.reconciliationDetail?.accounts ?? [])
  return (
    <span className="shrink-0 text-xs font-medium tabular-nums text-amber-700">
      {gapVerdict(gap)}
    </span>
  )
}
